import {
  Button,
  HelpText,
  Label,
  Modal,
  TextField,
} from '@lego/connect-components-react';
import { type RefObject, useMemo, useState } from 'react';
import { validateSimulationName } from './start-sim-modal/validators';

type Props = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLButtonElement | null>;
  currentName: string;
  onClose: () => void;
  onSubmit: (newName: string) => void;
};

export const RenameSimulationModal = ({
  isOpen,
  triggerRef,
  currentName,
  onClose,
  onSubmit,
}: Props) => {
  const [simulationName, setSimulationName] = useState(currentName);
  const simulationNameErrors = useMemo(
    () => validateSimulationName(simulationName),
    [simulationName],
  );
  const hasNameError =
    simulationName.length > 0 && simulationNameErrors.length > 0;

  const handleClose = () => {
    setSimulationName(currentName);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="small"
      triggerRef={triggerRef}
    >
      <Modal.Title>Rename Simulation</Modal.Title>
      <Modal.Content>
        <div>
          <Label>Simulation name</Label>
          <TextField
            id="simulation-name"
            placeholder="Input a unique simulation name"
            value={simulationName}
            onChange={(e) => setSimulationName(e.target.value)}
            validationState={hasNameError ? 'invalid' : undefined}
          />
          {hasNameError && (
            <HelpText id="simulation-name-error" variant="negative">
              {simulationNameErrors.join(' ')}
            </HelpText>
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button
          onClick={handleClose}
          appearance="ghost"
          variant="neutral"
          aria-label={'Cancel'}
        >
          Cancel
        </Button>
        <Button
          onClick={() => onSubmit(simulationName)}
          aria-label={'Submit'}
          disabled={
            simulationName === currentName ||
            validateSimulationName(simulationName).length > 0
          }
        >
          Rename
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
